import React from 'react'
import './IconFrameS.css'
import { useLanguage } from '../LanguageContext'

function IconFrameS(props) {
    const { language } = useLanguage()
    return (
        <div className={language === 'english' ? 'icon-frame-s' : 'icon-frame-s-pl'} style={{ width: props.width }}>
            <img src={props.icon} className='icon-svg-s' alt='decoration icon' />
            <span className='icon-title-s'>{props.text}</span>
        </div>
    )
}

export default IconFrameS